/* Good Bridge Music — premium micro-interactions.
   Restraint by design: only transform/opacity, hard guards for pointer:fine + reduced-motion.
   If JS never runs, nothing is hidden (reveal class is added by JS only). */
(() => {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(pointer: fine)').matches;

  /* ── 1. Scroll reveal (fade + small rise, staggered) ── */
  if (!reduce && 'IntersectionObserver' in window) {
    const targets = document.querySelectorAll(
      '.gbm-featured__grid-item, .gbm-vp__item, .gbm-consign-how__step, .gbm-pdp__related-card'
    );
    if (targets.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      targets.forEach((el, i) => {
        el.classList.add('gbm-reveal');
        el.style.setProperty('--reveal-delay', ((i % 6) * 55) + 'ms');
        io.observe(el);
      });
    }
  }

  /* ── 2. Hero spotlight (pointer-reactive amber light, lerp lag) ── */
  if (fine && !reduce) {
    const hero = document.querySelector('.gbm-hero');
    if (hero) {
      hero.classList.add('gbm-spotlight');
      let tx = 50, ty = 50, cx = 50, cy = 50, raf = null;
      const loop = () => {
        cx += (tx - cx) * 0.08;
        cy += (ty - cy) * 0.08;
        hero.style.setProperty('--spot-x', cx.toFixed(2) + '%');
        hero.style.setProperty('--spot-y', cy.toFixed(2) + '%');
        if (Math.abs(tx - cx) > 0.1 || Math.abs(ty - cy) > 0.1) {
          raf = requestAnimationFrame(loop);
        } else { raf = null; }
      };
      hero.addEventListener('pointermove', (e) => {
        const r = hero.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width) * 100;
        ty = ((e.clientY - r.top) / r.height) * 100;
        hero.style.setProperty('--spot-o', '1');
        if (!raf) raf = requestAnimationFrame(loop);
      }, { passive: true });
      hero.addEventListener('pointerleave', () => {
        hero.style.setProperty('--spot-o', '0');
      });
    }
  }
})();
